<template>
	<MegaMenu :menu="menu" menu-key="support">
		<div class="container">
			<div class="flex w-full flex-row pb-4 pt-0 lg:py-12">
				<div class="order-2 hidden justify-items-end lg:flex">
					<span
						class="cursor-pointer"
						@click="hideMegaMenu(megaMenu)"
					>
						<IconTimes class="650 h-5 w-5 hover:text-blue-400" />
					</span>
				</div>

				<div class="order-1 flex w-full flex-col gap-x-10 lg:flex-row">
					<div class="w-full lg:w-1/3">
						<p
							class="mt-4 pb-3 text-base font-medium leading-none text-blue-400 md:text-lg lg:m-0"
						>
							Help and support
						</p>
						<div class="flex flex-wrap lg:gap-x-10">
							<div class="w-full">
								<div class="flex flex-col text-gray-600">
									<p class="m-0 py-1">
										We are here when you need us.
									</p>
									<p class="m-0 py-1 lg:mb-4">
										Our customer support team are available
										<br />
										Mon - Fri 9:00am to 5:00pm.
									</p>
									<div class="my-4">
										<p class="m-0">
											24/7 Roadside assistance
										</p>
										<CarbarLink
											href="tel:1300227365"
											text-color="text-gray-650"
											class="font-medium"
											text="1300 227 365"
										/>
									</div>
									<div class="my-4">
										<p class="m-0">Accident management</p>
										<CarbarLink
											href="tel:1300620685"
											text-color="text-gray-650"
											class="font-medium"
											text="1300 620 685"
										/>
									</div>
								</div>
							</div>
						</div>
						<UnorderedList
							class="m-0 mt-4"
							icon-gap="p-0 lg:pl-8"
							items-padding-y=""
							:show-list-icon="true"
							:items="megaMenu.megaMenu[0]"
						>
							<!-- eslint-disable vue/no-unused-vars -->
							<!-- eslint-disable vue/no-template-shadow -->
							<template
								v-for="(item, index) in megaMenu.megaMenu[0]"
								:key="index"
								#[`${_kebabCase(item.label)}`]="{ item }"
							>
								<!-- eslint-enable vue/no-unused-vars -->
								<!-- eslint-enable vue/no-template-shadow -->
								<CarbarLink
									:href="item.link"
									:class="[item.class]"
									:underline="false"
									text-color="text-gray-650"
									font-size="text-base"
									class="group w-full py-2 md:py-3"
									@click="onMegaMenuLinkClick(megaMenu)"
								>
									<span>{{ item.label }}</span>
								</CarbarLink>
							</template>
							<template #icon>
								<IconPage
									class="my-2.5 hidden h-[22px] w-[22px] text-gray-500 lg:flex"
								/>
							</template>
						</UnorderedList>
					</div>
				</div>
			</div>
		</div>
	</MegaMenu>
</template>

<script setup>
import { kebabCase as _kebabCase } from 'lodash-es'
import CarbarLink from '@/components/links/CarbarLink.vue'
import UnorderedList from '@/components/lists/UnorderedList.vue'
import MegaMenu from '@/components/headers/megamenus/MegaMenu.vue'
import { headerModule } from '~/utils/Header.js'
import IconTimes from '@/assets/svg/common/ico-times.svg'
import IconPage from '@/assets/svg/header/ico-page.svg'

const props = defineProps({
	menu: {
		type: Object,
	},
})

const { hideMegaMenu, onMegaMenuLinkClick } = headerModule()

const megaMenu = computed(() =>
	props.menu.find((menuItem) => menuItem.key === 'support')
)
</script>
